// Turkish dictionary. Same keys as en.ts.

export const tr: Record<string, string> = {
  "dawn.era0": "Uçsuz bozkır",
  "dawn.era1": "Kağanlar",
  "dawn.era2": "Taş ve imparatorluk",
  "dawn.era3": "Cumhuriyet",
  "dawn.era4": "Göğün ötesi",
  'common.continue': 'Devam',
  'common.skip': 'Atla',
  'common.next': 'İleri',
  'common.finish': 'Bitir',
  'common.close': 'Kapat',
  'common.back': 'Geri',
  'common.send': 'Gönder',
  'common.begin': 'Başla',

  'hud.spoils': 'Ganimet',
  'hud.skillPts': 'Yetenek p.',
  'hud.cosmic': 'Kozmik',
  'hud.population': 'Nüfus',
  'hud.buildings': 'Bina',
  'hud.autoOn': 'Oto-toplama: açık',
  'hud.autoProgress': 'Oto-toplama: {have}/{need} toplayıcı bina',
  'hud.nextBuilding': 'Sonraki bina',
  'hud.needPop': 'önce nüfus',
  'hud.ascend': 'Yüksel',

  'wave.next': 'Sonraki dalga',
  'wave.waveN': 'Dalga {n}',
  'wave.bossN': 'Boss dalgası ({n})',
  'wave.incoming': 'Dalga geliyor',
  'wave.bossIncoming': 'Boss geliyor',
  'wave.now': 'ŞİMDİ',
  'wave.yourPower': 'Gücün',
  'wave.enemyPower': 'Düşman gücü',
  'wave.conquer': '{planet} fethi: çağ {goal}',
  'wave.conquered': '{planet} fethedildi',

  // çağ kapısı (her çağ atlamayı bekleyen boss)
  'gate.progress': '{boss} kapıda toplanıyor: %{pct}',
  'gate.atGate': '{boss} kapıda!',
  'gate.final': 'Son çağa ulaşıldı',
  'gate.summonTitle': 'Çağ kapısı açılıyor',
  'gate.summonSub': '{boss} kapıda toplanıyor. Onu yenersen yeni çağa geçersin; kapıyı yıkarsa soyun düşer.',
  'gate.freeProgress': 'Sonraki çağ: %{pct}',
  'gate.cleared': 'Kapı aşıldı',
  'gate.clearedSub': 'Önünde yeni bir çağ',

  'banner.repelled': 'Dalga püskürtüldü',
  'banner.overrun': 'Köy basıldı',
  'banner.onHorizon': '{enemy} ufukta',
  'banner.bossApproaches': 'Boss kapıya yürüyor',
  'banner.scattered': '{enemy} dağıldı',
  'banner.brokeThrough': '{enemy} savunmayı yardı',

  'milestone.autoTitle': 'Otomatik toplama açıldı',
  'milestone.autoSub': 'Halkın artık kendi kendine kaynak topluyor.',
  'milestone.settlementNow': 'Yerleşimin artık bir {name}',
  'milestone.settlementGrows': 'Yerleşimin büyüyor',

  'intro.begin': 'Başla',
  'intro.tagline': 'Bozkırın tozundan göğün hükümdarlığına.',
  'intro.story':
    'Ebedi mavi gök altında, bozkırda bir avuç otağ. Sen halkı yönetmezsin, onlara yol gösteren göğün iradesisin. Çağ çağ yüksel, düşersen küllerinden daha güçlü dön, ve gök bir tavan değil dönülecek yurt olana dek yıldızlara açıl.',

  'news.title': 'Yenilikler',
  'news.sub': 'Son ziyaretinden bu yana neler değişti (v{version})',
  'news.all': 'Tüm güncellemeler',

  'tut.s1.title': 'Hoş geldin',
  'tut.s1.text':
    'Bu senin halkın. Toplamak istediğin yere dokun; sarı daire oraya yerleşip çevredeki ağaç, taş ve madeni işler. Başka yere dokununca taşınır (masaüstünde fareyi takip eder).',
  'tut.s2.title': 'Kaynaklar',
  'tut.s2.text': 'Topladığın odun, taş, maden ve bilgi burada birikir.',
  'tut.s3.title': 'Yerleşimin',
  'tut.s3.text':
    'Halkın bu kaynaklarla kendi kendine bina kurar. Nüfus, bina sayısı ve sonraki bina için gereken kaynaklar burada.',
  'tut.s4.title': 'Dalgalar',
  'tut.s4.text':
    'Belirli aralıklarla yağmacılar gelir. Gücün yeterliyse püskürtürsün; bir dalga savunmayı yararsa soyun düşer, bilgelikle yeniden yükselirsin.',
  'tut.s5.title': 'Gerisi sende',
  'tut.s5.text':
    'Sonraki çağların her birini kapıda bir boss korur: onu yen, eserini al ve yönünü seç (ekonomi, asker, bilgi). 🔬 teknoloji, 👤 hesap ve geri bildirim. İyi oyunlar!',

  'account.title': 'Hesap',
  'account.feedbackLabel': 'Geri bildirim',
  'account.feedbackPlaceholder': 'Ne düşünüyorsun? Bug, fikir, his... her şey yardımcı olur.',
  'account.dangerZone': 'Tehlikeli bölge',
  'account.resetBtn': 'Tüm ilerlemeyi sıfırla (sıfırdan başla)',
  'account.resetConfirm':
    'Emin misin? Yetenek ağacı, kozmik güç, gezegenler ve şu anki oyun, hepsi silinir. Geri alınamaz.',
  'account.resetYes': 'Evet, her şeyi sıfırla',
  'account.resetNo': 'Vazgeç',
  'account.replayTutorial': 'Rehberi tekrar göster',
  'account.logout': 'Çıkış yap',
  'account.signIn': 'İlerlememi kaydetmek için giriş yap',
  'account.guest': 'Misafir olarak oynuyorsun. İlerlemen yalnızca bu cihazda.',
  'account.language': 'Dil',
  'account.supportLabel': 'Destek',
  'account.supportBtn': 'Bu oyunu destekle',

  'nudge.early': 'Nasıl gidiyor? Kısa bir geri bildirim çok değerli 🙏',
  'nudge.later': 'Buraya kadar geldin! Fikrini paylaşır mısın?',
  'nudge.cta': 'Geri bildirim',

  'login.title': 'Giriş',
  'login.sub': 'İlerlemeni her cihazda saklamak için giriş yap. İstersen atla, sonra 👤 menüsünden giriş yaparsın.',
  'login.guest': 'Önce oyna, sonra giriş yap',
  'login.emailPlaceholder': 'senin@eposta.com',
  'login.sendCode': 'Kod gönder',
  'login.codePlaceholder': '6 haneli kod',
  'login.verify': 'Doğrula',
  'login.sending': 'Gönderiliyor...',
  'login.codeSent': 'E-postana bir kod gönderildi.',
  'login.verifying': 'Doğrulanıyor...',
  'login.errGeneric': 'Bir şeyler ters gitti, tekrar dene.',
  'login.errCode': 'Kod yanlış ya da süresi dolmuş.',

  'death.title': 'Soyun düştü',
  'death.lede':
    '{age}. Çağa ulaştın ve {waves} dalga dayandın. Zorlukla kazandığın bilgeliği harca, sonra yeniden yüksel.',
  'death.bossLede':
    '{boss} kapını yıktı: {age}. Çağ, {waves} dalga. Karşısına yeniden çıkmadan önce savunma yetenekleri ve asker kartlarıyla güçlen.',
  'death.wavesHeld': 'Dayanılan dalga',
  'death.ageReached': 'Ulaşılan çağ',
  'death.skillPoints': 'Yetenek puanı',
  'death.restart': 'Yeniden yüksel',
  'death.ascendTo': '🚀 {planet} gezegenine yüksel (+{gain} kozmik)',

  'offline.title': 'Sen yokken',
  'offline.sub': 'Halkın {time} boyunca çalışmaya devam etti.',
  'offline.collect': 'Topla',

  'cards.title': 'Bir çağ dönüyor',
  'cards.sub': 'Halkın için bir yön seç.',

  'cat.economy': 'Ekonomi',
  'cat.military': 'Asker',
  'cat.knowledge': 'Bilgi',
  'lab.active': 'Aktif',
  'lab.cost': 'Maliyet',
  'lab.title': 'Laboratuvar',
  'lab.spoilsWord': 'Ganimet',
  'lab.techs': 'Teknolojiler (ganimet)',
  'lab.artifacts': 'Eserler (kaynakla etkinleştir)',
  'lab.artifactsHint': 'Eser kazanmak için her çağ kapısındaki bossu yen.',

  'err.invalid_email': 'Geçerli bir e-posta gir.',
  'err.send_failed': 'Kod gönderilemedi, birazdan tekrar dene.',
  'err.missing_fields': 'Eksik bilgi.',
  'err.need_code': 'Önce kod iste.',
  'err.too_many_attempts': 'Çok fazla deneme. Yeni kod iste.',
  'err.code_expired': 'Kodun süresi doldu.',
  'err.code_wrong': 'Kod yanlış.',
  'err.invalid_save': 'Geçersiz kayıt.',
  'err.empty_feedback': 'Boş geri bildirim.',
  'err.auth_required': 'Giriş gerekli.',
  'account.feedbackEmpty': 'Önce bir şeyler yaz.',
  'account.feedbackThanks': 'Teşekkürler, gönderildi!',
  'account.feedbackError': 'Gönderilemedi, tekrar dene.',
  'account.btnTitle': 'Hesap ve geri bildirim',
  'milestone.ageDawns': '{n}. Çağ doğuyor',
  'milestone.synergy': 'Sinerji: {name}',
  'milestone.artifactFound': 'Eser bulundu: {name}',
  'milestone.artifactHint': 'Kaynak harcayarak etkinleştir',
  'milestone.artifactActive': '{name} etkinleşti',
  'milestone.conquerReady': '{planet} artık senin',
  'milestone.conquerReadySub': 'Yüksel: kozmik gücü topla ve sıradaki dünyaya geç',
  'milestone.ascended': '{planet} gezegenine yükseldin',
  'milestone.ascendedSub': '+{gain} kozmik güç',
  'combat.dodge': 'Savuştu!',
  'combat.miss': 'Iska',
  'combat.block': 'Blok',
  'lab.owned': 'Alındı',
  'lab.activate': 'Etkinleştir',
  'ui.soundTitle': 'Ses aç/kapat',
  'login.signedIn': 'oturum açık',
  'login.offline': 'çevrimdışı',
  'skill.lv': 'Sv {lvl}/{max}',
  'skill.max': 'MAKS',
  'offline.nothing': 'Sen yokken bir şey toplanmadı.',
  'death.firstLede': 'Bu bir son değil, döngünün kendisi: her düşüş bilgelik kazandırır. Harca ve daha güçlü yüksel.',
  'death.spendHint': 'Puanlarını harca, sonra yeniden yüksel.',
  'err.google_failed': 'Google girişi başarısız.',
  'login.or': 'veya',

  // Wave skip + voluntary retirement (v0.10)
  'wave.sendNow': 'Dalgayı şimdi gönder',
  'retire.btn': 'Medeniyeti bitir',
  'retire.lockedAt': 'Çağ {n} ile açılır',
  'retire.confirm': 'Bitirmek için tekrar dokun',
  'death.retireLede': 'Bu soyu kendi kararınla noktaladın: {age}. Çağ, {waves} dalga dayanıldı. Bilgeliği harca, sonra daha güçlüsünü kur.',
};
